import React from 'react';

// GLOBAL FUNCTIONS
import { formatDateTime } from 'functions.js';

// LOCAL COMPONENTS
import AddComment from '../tools/AddComment';
import DeleteComment from '../tools/DeleteComment';

// STYLES
import styles from './taskComments.module.scss';

// MAIN COMPONENT
const TaskComments = ({ task: { arryComments: comments = [], ...task }, rowNumber }) => (
  <div className={styles.container}>
    <AddComment taskID={task.task_id} rowNumber={rowNumber} />
    {!!comments.length && (
      <div className={styles.commentList}>
        {comments.map((comment, i) => (
          <div key={i} className={styles.commentItem}>
            <div className={styles.commentInner}>
              <div>
                <div className={styles.commentBody}>{comment.comment_body}</div>
                <div className={styles.commentMeta}>
                  <span className="text-muted">by</span>&nbsp;
                  {comment.comment_author}&nbsp;
                  <span className="text-muted">on</span>&nbsp;
                  {formatDateTime(comment.comment_date)}
                </div>
              </div>
              <DeleteComment commentId={comment.comment_id} rowNumber={rowNumber} />
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

// EXPORT
export default TaskComments;
